import React, { Component } from 'react';
import moment from 'moment';

export default class TimeRange extends Component {
    changeHandler(event) {
        this.props.onChange(parseInt(event.target.value, 10));
    }
    render() {
        let futureDay       = moment().add(this.props.daysInFuture, 'days').startOf('day');
        let isToday         = this.props.daysInFuture === 0;
        let absoluteDate    = futureDay.format('dddd D MMM gggg');
        let relativeDate    = isToday ? 'Today' : moment().startOf('day').to(futureDay);

        const style = {
            timeRange: {
                position: 'absolute',
                top: 0,
                left: 190,
                right: 190,
                padding: 24,
                bottom: 0
            },
            day: {
                textAlign: 'center',
                paddingBottom: 10,
                textTransform: 'capitalize'
            },
            daySpan: {
                color: '#999'
            }
        };

        return (
            <div style={style.timeRange}>
                <div style={style.day}>{relativeDate} <span style={style.daySpan}>&middot; {absoluteDate}</span></div>
                <input type="range"
                       min="0"
                       max="120"
                       onChange={this.changeHandler.bind(this)}
                       value={this.props.daysInFuture} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TimeRange.js